import React from 'react';

import { CreditCard } from '@generated-types';
import { isAndroid, isIOS } from '@utils/platform';

import { GoogleWallet, ApplePay, V4GoogleWallet } from './components';

type V4DigitalWalletProps = {
    card: CreditCard;
};

export const V4DigitalWallet = ({ card }: V4DigitalWalletProps) => {
    if (isAndroid()) return <V4GoogleWallet card={card} />;
    if (isIOS()) return <ApplePay />;

    return null;
};

export const DigitalWallet = () => {
    if (isAndroid()) return <GoogleWallet />;
    if (isIOS()) return <ApplePay />;

    return null;
};
